import { render } from "./NameBubble2d.vue?vue&type=template&id=aab3c5fa&scoped=true"
import script from "./NameBubble2d.vue?vue&type=script&lang=js"
export * from "./NameBubble2d.vue?vue&type=script&lang=js"

import "./NameBubble2d.vue?vue&type=style&index=0&id=aab3c5fa&scoped=true&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aab3c5fa"]])

export default __exports__